import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { dateToRelativeTrans } from '@wix/da-ds/pkg/Time/functions';
import DSModal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import BirthdayCake from '@wix/da-ds/pkg/Icons/BirthdayCake';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { Url } from '@wix/da-url';
import CoreSymbol from '@wix/da-ds/pkg/Indicators/CoreSymbol';
import ListItemDiv from '@wix/da-ds/pkg/List/ListItem/dsPresets/ListItemDiv';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { ResourceType } from '../types/resource';
import { BiData } from '@wix/da-bi/pkg/events';
import s from './BirthdayPopup.scss';
const BirthdayPopup = (props)=>{
    var _data_users;
    const { data, isInitialized, isLoading, initialize, requestClose } = props;
    const { t } = useTranslation();
    useEffect(()=>{
        if (!isInitialized) {
            initialize();
        }
    }, [
        isInitialized,
        initialize
    ]);
    const hasBirthdays = data && data.users && data.users.length > 0;
    return /*#__PURE__*/ React.createElement(DSModal, {
        isOpen: true,
        heading: t('birthdayPopup.header'),
        className: s['root'],
        layoutClassName: s['layout-root'],
        onRequestClose: requestClose
    }, /*#__PURE__*/ React.createElement("section", {
        className: s['content']
    }, isInitialized && hasBirthdays && ((_data_users = data.users) === null || _data_users === void 0 ? void 0 : _data_users.map((user, index)=>{
        // convert timestamp to relative date - 3 days ago
        const birthday = user.birthweekBirthday ? dateToRelativeTrans(user.birthweekBirthday, false, true) : undefined;
        const biData = BiData({
            evid: 101,
            typeid: ResourceType.USER,
            itemid: user.userId,
            sectionname: 'birthday'
        });
        return /*#__PURE__*/ React.createElement(ListItemDiv, {
            label: /*#__PURE__*/ React.createElement(BiLink, {
                href: Url.userLink(user.username),
                target: "_blank",
                rel: "noreferrer",
                biData: biData
            }, user.username),
            subLabel: birthday && t(birthday.key, {
                count: birthday.value
            }),
            prefix: /*#__PURE__*/ React.createElement(BiLink, {
                href: Url.userLink(user.username),
                target: "_blank",
                className: s['avatar'],
                rel: "noreferrer",
                biData: biData
            }, /*#__PURE__*/ React.createElement("img", {
                src: user.usericon,
                alt: user.username
            })),
            suffix: !user.isGroup ? /*#__PURE__*/ React.createElement(BiLink, {
                href: Url.giveCoreMembership(user.username),
                className: s['gift-core'],
                biData: BiData({
                    evid: 375,
                    referral_info: ReferralType.WATCH_BIRTHDAY
                })
            }, /*#__PURE__*/ React.createElement(CoreSymbol, {
                size: IconSize.SMALL,
                className: s['core-symbol']
            }), t('birthdayPopup.cta.core')) : /*#__PURE__*/ React.createElement(BiLink, {
                href: Url.userLink(user.username),
                className: s['send-wishes'],
                target: "_blank",
                rel: "noreferrer",
                biData: BiData({
                    evid: 101,
                    typeid: ResourceType.USER,
                    itemid: user.userId,
                    sectionname: 'birthday_send_wishes'
                })
            }, t('birthdayPopup.cta.noncore')),
            key: user.userId
        });
    })), isInitialized && !hasBirthdays && /*#__PURE__*/ React.createElement("div", {
        className: s['empty-state']
    }, /*#__PURE__*/ React.createElement(BirthdayCake, {
        className: s['cake']
    }), t('birthdayPopup.empty')), (!isInitialized || isLoading) && /*#__PURE__*/ React.createElement(LoadingIndicator, null)));
};
BirthdayPopup.displayName = 'BirthdayPopup';
export default BirthdayPopup;

//# sourceMappingURL=BirthdayPopup.js.map